export default __webpack_public_path__ + "static/media/011-harp.f2812b61.svg";